export const SecurityContext = {
	Host: "web_Host",
	Menu: "portal_Menu",
	RestrictByAssociation: "restrictByAssociation",
	AdminGroupUser: "adminGroupUser"
} as const;

export const SecurityContextPermission = {
	False: "false"
} as const;

export const ApplicationName = "Sandfield.OnEvent.Product.Portal";